import { render, staticRenderFns } from "./EditProforma.vue?vue&type=template&id=c96a5aa2&scoped=true&lang=pug&"
import script from "./EditProforma.vue?vue&type=script&lang=ts&"
export * from "./EditProforma.vue?vue&type=script&lang=ts&"
import style0 from "./EditProforma.vue?vue&type=style&index=0&id=c96a5aa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c96a5aa2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
